import React from 'react';
import { FaTimes, FaStar } from 'react-icons/fa';

const ReviewModal = ({ review, onClose }) => {
  if (!review) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button">
          <FaTimes />
        </button>
        
        <div className="text-center">
          <img 
            src={review.avatar} 
            alt={review.name} 
            className="w-24 h-24 rounded-full mx-auto border-4 border-slate-950 mb-4" 
          />
          <h3 className="text-2xl font-bold text-white mb-1">{review.name}</h3>
          <p className="text-sm text-slate-400 mb-4">{review.title}</p>
        </div>

        <div className="flex justify-center text-amber-400 mb-4">
          <FaStar />
          <FaStar />
          <FaStar />
          <FaStar />
          <FaStar />
        </div>
        
        <p className="text-slate-400 italic text-center text-lg mb-6">"{review.quote}"</p>
      </div>
    </div>
  );
};

export default ReviewModal;